export default __webpack_public_path__ + "static/media/bg.7967560f.png";